import type {TableConfiguration} from 'schema/table/types';
import type {AgentPerson} from 'services/agent/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {publisherAgentDefaultColumns} from './columns';

export const publisherAgentTableConfig: TableConfiguration<AgentPerson> = {
  ...defaultTableConfig,
  defaultColumns: publisherAgentDefaultColumns,
};
